export const breakpoint = ['xl', 'lg', 'md', 'sm'];
export const getBreakpointValueWithUnit = (config) => `${config.theme.breakpoints.values[config.breakpoint]}${config.theme.breakpoints.unit}`;
